import React from 'react';
import './FremWork.css'

const FremWork = () => {
    return (
        <div className='bg-about lg:p-10 p-5'>
    <div class="lg:flex gap-5 mt-20" >
  <div class="single-chart mt-10 " data-aos="zoom-out">
    <svg viewBox="0 0 36 36" class="circular-chart orange">
      <path class="circle-bg"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path class="circle"
        stroke-dasharray="90, 100"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="20.35" class="percentage">80%</text>
    </svg>
    <p className='text-white text-center text-3xl font-bold'>Front End</p>
  </div>
  
  <div class="single-chart mt-10" data-aos="zoom-out">
    <svg viewBox="0 0 36 36" class="circular-chart green">
      <path class="circle-bg"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path class="circle"
        stroke-dasharray="85, 100"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="20.35" class="percentage">85%</text>
    </svg>
    <p className='text-white text-center text-3xl font-bold'>BackEnd</p>
  </div>

  <div class="single-chart mt-10" data-aos="zoom-out">
    <svg viewBox="0 0 36 36" class="circular-chart blue">
      <path class="circle-bg"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path class="circle"
        stroke-dasharray="90, 100"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="20.35" class="percentage">90%</text>
    </svg>
    <p className='text-white text-center text-3xl font-bold'>Responsive Design</p>
  </div>

</div>
        </div>
    );
};

export default FremWork;